import "./Register.css";
import robotImg from "./assets/robort.png";
import { Link } from "react-router-dom";

export default function Register() {
  return (
    <div className="register-page">
      <div className="register-card">

        {/* LEFT SIDE */}
        <div className="register-left">
          <img src={robotImg} alt="Robot" className="robot-img" />
          <h2>Welcome to BCI 👋</h2>
          <p>Your AI learning journey starts here!</p>

          <p>
            Get to know us{" "}
            <Link to="/about" className="about-link">
              about
            </Link>
          </p>
        </div>

        {/* RIGHT SIDE */}
        <div className="register-right">
          <h2>Create Your Account</h2>

          <input type="text" placeholder="Full Name" />
          <input type="email" placeholder="Email Address" />
          <input type="tel" placeholder="Mobile Number" />

          <select>
            <option>Select Course</option>
            <option>Python</option>
            <option>Web Development</option>
            <option>Data Analytics</option>
            <option>AI & ML</option>
          </select>

          <div className="password-row">
            <input type="password" placeholder="Password" />
            <input type="password" placeholder="Confirm Password" />
          </div>
          <p className="login-text">
            Already have an account?{" "}
            <Link to="/login">
              <span>Login</span>
            </Link>
          </p>

         

          <button className="register-btn">Register Now</button>

          
        </div>

      </div>
    </div>
  );
}
